module.exports = __webpack_public_path__ + "img/emitFacebeauty04.e36ae12f.png";